import _ from '@lodash';
import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import CaptchaTypeEditDto from 'app/admin/captchatype/dto/CaptchaTypeEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';
import EnumDto from 'modules/base/dto/enum/EnumDto';

class CaptchaTypeEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'captchaTypeEditControl';
		this.ENGINECONTROL = 'engineTypeControl';
	}

	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new CaptchaTypeEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new CaptchaTypeEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	getCaptchaTypeSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getCaptchaTypeSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	getEngineTypeSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.ENGINECONTROL}/getEngineTypeSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	// getEngineNames() {
	// 	return new Promise((resolve, reject) => {
	// 		this.connection
	// 			.get(`/${this.CONTROL}/getEngineNames`)
	// 			.then(response => resolve(response.data))
	// 			.catch(reject);
	// 	});
	// }

	/**
	 * @return {Promise<EnumDto[]>}
	 */
	getEngineNames() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getEngineNames`)
				.then(response => resolve(_.isArray(response.data) ? response.data.map(d => new EnumDto().setup({ label: d.label, value: d.name })) : []))
				.catch(reject);
		});
	}

	getParameterSelection(engineName, paramKey) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getParameterSelection`, {
					engineName,
					paramKey
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	getFontSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getFonts`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	getFadeInMode(engineName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getFadeInMode`, {
					engineName
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	getParameterSelectionEnum(engineName, paramKey) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getParameterSelectionEnum`, {
					engineName,
					paramKey
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	getFadeShape(engineName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getFadeShape`, {
					engineName
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	getMotionBlur(engineName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getMotionBlur`, {
					engineName
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	getLocale(engineName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getLocale`, {
					engineName
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	getMiniGameCategory(engineName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getMiniGameCategory`, {
					engineName
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new CaptchaTypeEditService();
